export const patchWorkCenterInitialState = {
	workCenters: null,
	error: null,
	errorShow: false,
	loading: false,
};
